'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useSelector } from 'react-redux';
import BannerSection from 'pricing-pages-unified-ui/components/banners/BannerSection';
import FooterMicrocopy from 'pricing-pages-unified-ui/components/common/FooterMicrocopy';
import Question from 'pricing-pages-unified-ui/components/common/Question';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import { useDocumentTitle } from 'pricing-pages-unified-ui/utils/DocumentUtils';
import PhoneSupport from 'pricing-pages-unified-ui/components/common/PhoneSupport';
import FailedLoadBanner from 'pricing-pages-unified-ui/components/loading/FailedLoadBanner';
import FallbackErrorBanner from '../loading/FallbackErrorBanner';
import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { useAnchorLinkScroll } from '../../utils/customHooks';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import { useMon570 } from '../../selectors/ExperimentTreatmentSelectors';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useQueryParamTerm } from '../../utils/stateUtils';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
import NavLayout, { HeaderBackdrop } from '../mon569-tabs/NavLayout';
import { MON569_SCREENS } from '../../constants/Tracking';
import MON570FeatureCardWrapper from '../product-pages/MON570FeatureCardWrapper';
import RecommendedBundlesSection from '../product-pages/bundles-section/RecommendedBundlesSection';
import PhoneSupportWrapper from '../common/phone-numbers/PhoneSupportWrapper';
import { HubCalculator } from '../common/Calculator';
import { FaqsConfig } from '../../constants/FaqsConfig';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import Mon569HubTierInfo from './Mon569HubTierInfo';
import { useParams } from 'react-router-dom';
import CurrencyPicker from '../common/CurrencyPicker';
import Faq from '../common/Faq';
import PhoneSupportFooter from '../common/PhoneSupportFooter';
import CustomerSupport from '../common/CustomerSupport';
const PageContainer = styled.div.withConfig({
  displayName: "ProductPage__PageContainer",
  componentId: "sc-1pj1u03-0"
})(["background-color:", ";min-height:100vh;"], OLAF);
const HubInfoContainer = styled.div.withConfig({
  displayName: "ProductPage__HubInfoContainer",
  componentId: "sc-1pj1u03-1"
})(["max-width:1000px;margin-left:50px;padding-top:40px;", ";", ";"], breakpoint.cs(_t || (_t = _`
    padding: 20px 20px 0;
    margin: auto;
  `)), breakpoint.phone(_t2 || (_t2 = _`
    padding-top: 20px;
  `)));
const PageContentContainer = styled.div.withConfig({
  displayName: "ProductPage__PageContentContainer",
  componentId: "sc-1pj1u03-2"
})(["max-width:1200px;margin:auto;", ";"], breakpoint.cs(_t3 || (_t3 = _`
    padding: 20px 20px 0;
  `)));

const ProductPage = ({
  productLine
}) => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle(productLine.toLowerCase());
  const {
    tab
  } = useParams();
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const {
    isVariant: isMon570Variant
  } = useMon570(productLine);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: MON569_SCREENS[productLine],
      tab
    });
  }, [productLine, tab]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsxs(PageContainer, {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(HeaderBackdrop, {}), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsxs(NavLayout, {
      selectedNavItem: productLine.toLowerCase(),
      selectedTab: tab,
      children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
        name: `${productLine}_PAGE`
      }), /*#__PURE__*/_jsxs(HubInfoContainer, {
        children: [/*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsx(BannerSection, {
          productLine: productLine,
          screen: `${MON569_SCREENS[productLine]}-${tab}`
        }), /*#__PURE__*/_jsx(Mon569HubTierInfo, {
          productLine: productLine,
          selectedTab: tab
        }, productLine)]
      })]
    }), /*#__PURE__*/_jsxs(PageContentContainer, {
      children: [isMon570Variant && /*#__PURE__*/_jsx(MON570FeatureCardWrapper, {
        productLine: productLine
      }), /*#__PURE__*/_jsx(RecommendedBundlesSection, {
        productLine: productLine
      }), /*#__PURE__*/_jsx(PhoneSupportWrapper, {
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          phoneSourceId: `${productLine.toLowerCase()}-middle`,
          screen: `${MON569_SCREENS[productLine]}-${tab}`
        })
      }), /*#__PURE__*/_jsx(HubCalculator, {
        productLine: productLine,
        screen: `${MON569_SCREENS[productLine]}-${tab}`
      }), /*#__PURE__*/_jsx(CustomerSupport, {}), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[productLine].map((_ref) => {
          let {
            questionKey
          } = _ref,
              passthroughOptions = _objectWithoutPropertiesLoose(_ref, ["questionKey"]);

          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
        phoneSourceId: `${productLine.toLowerCase()}-footer`,
        screen: `${MON569_SCREENS[productLine]}-${tab}`
      })]
    })]
  });
};

export default ProductPage;